import { adminInstrumentTypesPath, instrumentPath, instrumentsPath } from '@/shared/lib/routes'
import {
  RETURN_TO_INSTRUMENT_TYPES,
  instrumentTypesFilterQuery,
  resolveReturnFilters,
  resolveReturnTo,
} from '@/shared/lib/instrument-edit-return-to'

interface ResolveInstrumentEditCancelPathParams {
  isEdit: boolean
  instrumentId: number | null | undefined
  /** Raw `returnTo` prop from the server — re-allowlisted here before use. */
  returnTo: unknown
  /** Raw `returnFilters` prop from the server — re-allowlisted here before use. */
  returnFilters?: unknown
}

/**
 * The instrument edit form (REBUILD-381) is reachable both from the instrument detail
 * page and from the Instrument Types index (expanded instrument list). Cancel must
 * return to whichever one the user actually came from, so this only trusts the
 * allowlisted `returnTo` origin rather than always assuming the instrument detail page.
 * When returning to Instrument Types, the filters/expanded type active when the user left
 * ride along too (REBUILD-388/JW 386) — Cancel used to always land on a reset index.
 */
export const resolveInstrumentEditCancelPath = ({
  isEdit,
  instrumentId,
  returnTo,
  returnFilters,
}: ResolveInstrumentEditCancelPathParams): string => {
  if (!isEdit) return instrumentsPath()
  if (resolveReturnTo(returnTo) === RETURN_TO_INSTRUMENT_TYPES) {
    return adminInstrumentTypesPath(instrumentTypesFilterQuery(resolveReturnFilters(returnFilters)))
  }
  return instrumentId ? instrumentPath(instrumentId) : instrumentsPath()
}
